module.exports = __webpack_public_path__ + "img/heart@3x.dfb51479.png";